import { AnyAction } from 'redux';

import {
    SUPPLIER_DETAIL_DOCUMENTS_DELETE,
    SUPPLIER_DETAIL_DOCUMENTS_RECEIVED,
    SUPPLIER_DETAIL_DOCUMENTS_RENAME,
    SUPPLIER_DETAIL_DOCUMENTS_SET_SHOP_VISIBILITY,
    SUPPLIER_DETAIL_DOCUMENTS_SET_SUPPLIER_DIRECTORY_VISIBILITY,
    SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_PROGRESS,
    SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_START,
    SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_SUCCESS,
} from './supplier-detail-documents-actions';
import { SUPPLIER_DETAIL_RESET } from '../../store/supplier-detail-actions';
import { SupplierDocument } from '../models/supplier-detail-document';

export interface SupplierDetailDocumentsReducerState {
    documents: SupplierDocument[];
}

const initialDocumentsReducerState: SupplierDetailDocumentsReducerState = {
    documents: [],
};

export const supplierDetailDocumentsReducer = (
    state: SupplierDetailDocumentsReducerState = initialDocumentsReducerState,
    action: AnyAction
): SupplierDetailDocumentsReducerState => {
    switch (action.type) {
        case SUPPLIER_DETAIL_RESET: {
            return initialDocumentsReducerState;
        }

        case SUPPLIER_DETAIL_DOCUMENTS_RECEIVED: {
            return {
                ...state,
                documents: action['supplierDocuments'],
            };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_RENAME: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], title: action['title'] };
            return { ...state, documents: nextDocuments };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_SET_SHOP_VISIBILITY: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = {
                ...nextDocuments[index],
                isVisibleOnProductPages: action['isVisibleOnProductPages'],
            };
            return { ...state, documents: nextDocuments };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_SET_SUPPLIER_DIRECTORY_VISIBILITY: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = {
                ...nextDocuments[index],
                isVisibleInSupplierDirectory: action['isVisibleInSupplierDirectory'],
            };
            return { ...state, documents: nextDocuments };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_DELETE: {
            return {
                ...state,
                documents: state.documents.filter(document => document.id !== action['id']),
            };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_START: {
            return {
                ...state,
                documents: [...state.documents, action['document']],
            };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_PROGRESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], uploadProgress: action['progress'] };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        case SUPPLIER_DETAIL_DOCUMENTS_UPLOAD_SUCCESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...action['document'], uploadProgress: undefined };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        default: {
            return state;
        }
    }
};
